import { Box, Button, Chip, Grid, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import CustomNoRowsOverlay from "../../../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import MainCard from "../../../../../components/Maincard";
import HeadingCard from "../../../../newComponent/NewCardsComp/HeadingCard";
import CustomPopup from "../../../../../components/CustomPopup";
import AddMetaCampaignForm from "./AddMetaCampaignForm";
import { useGetTokenOrLogout } from "../../../../../utils/token";
import DenyIcon from "../../../../newComponent/iconsComp/DenyIcon";
import EditIconcomp from "../../../../newComponent/iconsComp/EditIconcomp";
import ConfirmationPopup from "../../../../../components/ConfirmationPopup";
import CustomSnackbar from "../../../../components/ui-component/snackbar/CustomSnackbar";
import EditMetaCampaignForm from "./EditMetaCampaignForm";
import LoaderComp from "../../../../newComponent/LoaderComp/Loader";
import SearchTextFieldComp from "../../../../newComponent/newtextfieldComp/SearchTextFieldComp";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function ShowAllMetaCampaign() {
  const getTokenOrLogout = useGetTokenOrLogout();
  const userId = localStorage.getItem("userId");
  const userRole =localStorage.getItem('userRole')
  const [metaCampaignData, setMetaCampaignData] = useState([]);
  const [originalCampaignData, setOriginalCampaignData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [addPopup, setAddPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [editPopup, setEditPopup] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState(null);

  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      const token = getTokenOrLogout();
      if (!token) return;
      let headers = {
        Authorization: `Bearer ${token}`,
      };
      try {
        setLoading(true);
        const response = await fetch(`${API_ENDPOINT}facebook-campaign`, {
          headers,
        });
        const data = await response.json();
        if (response.ok) {
          setMetaCampaignData(data);
          setOriginalCampaignData(data);
          setSearchData(data);
          setLoading(false);
        } else if (response.status === 400) {
          setOriginalCampaignData([]);
          showSnackbar(data.message, "error");
          setLoading(false);
        } else {
          setOriginalCampaignData([]);
          showSnackbar(data.message, "error");
          setLoading(false);
        }
      } catch (error) {
        setOriginalCampaignData([]);
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, [userId]);

  const columns = [
    {
      headerName: "Action",
      width: 100,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <Box display="flex" gap={2}>
          {(userRole ==="data_entry") && ( 
          <EditIconcomp
            tooltipTitle="Edit"
            fontSize="0.9rem"
            onClick={() => handleEditOpenPopup(params?.row)}
          />
          )}

          {/* <DenyIcon
            tooltipTitle="Delete"
            fontSize="0.9rem"
            onClick={() => handleDeleteOpenPopup(params.row?.id)}
          /> */}
        </Box>
      ),
    },
      
    {
      field: "facebook_campaign_name",
      headerName: "Facebook Campaign Name",
      headerClassName: "header-cell",
      width: 350,
      valueGetter: (params) => params?.row?.name || "",
      renderCell: (params) => <Typography>{params.row.name}</Typography>,
    },
    {
      field: "meta_form_name",
      headerName: "Meta Form Name",
      headerClassName: "header-cell",
      width: 300,
      valueGetter: (params) => params?.row?.meta_form_name || "",
      renderCell: (params) => <Typography>{params.row.meta_form_name}</Typography>,
    },

    {
      field: "stm_campaign_name",
      headerName: "Stm Campaign Name",
      headerClassName: "header-cell",
      width: 350,
      valueGetter: (params) => params?.row?.stm_campaign?.campaign_name || "",
      renderCell: (params) => (
        <Typography>{params.row.stm_campaign?.campaign_name}</Typography>
      ),
    },

    {
      field: "sub_service_heder_name",
      headerName: "Sub Service Header Name",
      headerClassName: "header-cell",
      width: 350,
      valueGetter: (params) =>
        params?.row?.sub_service_key_id?.name || params?.row?.other || "",
      renderCell: (params) => (
        <Typography>
          {params?.row?.sub_service_key_id?.name} 
        </Typography>
      ),
    },

    {
      field: "service",
      headerName: "Service",
      headerClassName: "header-cell",
      width: 250,
      valueGetter: (params) => params?.row?.service_id?.service_name || "",

      renderCell: (params) => (
        <Typography>{params?.row?.service_id?.service_name} </Typography>
      ),
    },

    {
      field: "sub_service",
      headerName: "Sub Service",
      headerClassName: "header-cell",
      width: 300,
      valueGetter: (params) => params?.row?.sub_service_id?.name || "",

      renderCell: (params) => (
        <Typography>{params?.row?.sub_service_id?.name} </Typography>
      ),
    },
     {
      field: "admission_program_id",
      headerName: "Admission Program",
      headerClassName: "header-cell",
      width: 200,
      valueGetter: (params) => params?.row?.admission_program_id?.name || "",

      renderCell: (params) => (
        <Typography>{params?.row?.admission_program_id?.name} </Typography>
      ),
     },
    {
      field: "notes_key",
      headerName: "Notes Key",
      headerClassName: "header-cell",
      width: 200,
      valueGetter: (params) => params?.row?.key_for_note || "",

      renderCell: (params) => (
        <Typography>{params?.row?.key_for_note?.map((item) => item).join(", ")} </Typography>
         // <div>{params?.row?.keys_arr?.map((item) => item).join(", ")}</div>
      ),
    },
     {
      field: "status",
      headerName: "Status",
      headerClassName: "header-cell",
      width: 200,
      valueGetter: (params) => params?.row?.sub_service_id?.name || "",

      renderCell: (params) => (
        <>   {params?.row?.is_active===0 ?
          <Chip label="Inactive" size="small" variant="contained" color="error"/> :
                    <Chip label="Active" size="small" variant="contained" color="secondary"/> 

        }</>
   
      ),
    },
  ];

  const handleOpenAddPopup = () => {
    setAddPopup(true);
  };

  const handleCloseAddPopup = () => {
    setAddPopup(false);
  };

  const handleDeleteOpenPopup = (rowId) => {
    setDeletePopup(true);
    setSelectedRowId(rowId);
  };

  const handleDeleteClosePopup = () => {
    setDeletePopup(false);
  };

  const handleEditOpenPopup = (rowData) => {
    setEditPopup(true);
    setSelectedRowData(rowData);
  };

  const handleEditClosePopup = () => {
    setEditPopup(false);
  };

  const handleDeleteCampaign = async () => {
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const formdata = {
      user_id: parseInt(userId),
      fb_campaign_id: selectedRowId,
    };
    try {
      const response = await fetch(
        `${API_ENDPOINT}facebook-campaign/delete-fb-campaign`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(formdata),
        }
      );
      const result = await response.json();
      if (response.ok) {
        showSnackbar("Campaign Deleted Successfully");

        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else if ([400, 401, 403, 500].includes(response.status)) {
        showSnackbar(result.message, "error");
      } else {
        showSnackbar("Internal Server Error", "error");
      }
    } catch (error) {
      showSnackbar("Internal Server Error", "error");
    }
  };

  // Search by all table column

  const handleSearchByName = (e) => {
    const value = e.target.value.toLowerCase()?.replace(/\s+/g, ""); // Normalize search value (lowercase and remove spaces)

    let filteredData1 = searchData.filter((data) => {
      // Check each field for a match with the search value
      const fieldsToSearch = [
        `${data?.name || ""}`,
        `${data?.stm_campaign?.campaign_name || ""}`,
        `${data?.service_id?.service_name || ""}`,
        `${data?.sub_service_id?.name || ""}`,
        `${data?.sub_service_key_id?.name || ""}`,
      ];

      // Check if any of the fields contain the search value
      return fieldsToSearch.some((field) =>
        field.toLowerCase()?.replace(/\s+/g, "").includes(value)
      );
    });

    setMetaCampaignData(filteredData1); // Update the filtered data
  };

  return (
    <>
      <LoaderComp isLoading={loading} />
      <Grid container spacing={2}>
        {/* Heading */}
        <Grid item xs={12} lg={3} md={4} sm={6}>
          <HeadingCard label="Meta Campaigns" />
        </Grid>
{(userRole ==="data_entry") && ( 
        <Grid item xs={12} lg={9} md={8} sm={6} textAlign="end">
          <Button
            variant="contained"
            size="medium"
            style={{ borderRadius: "7px", background: "#46b1ff" }}
            onClick={handleOpenAddPopup}
          >
            {" "}
            Add Meta Campaign
          </Button>
        </Grid>
        )}
        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={2}>
              <Grid item xs={12} textAlign="end">
                <SearchTextFieldComp onChange={handleSearchByName} />
              </Grid>
              <Grid item xs={12}>
              

                <DataGrid
                              rows={metaCampaignData}
                              columns={columns}
                              autoHeight
                              slots={{
                                noRowsOverlay: CustomNoRowsOverlay,
                              }}
                              initialState={{
                                pagination: {
                                  paginationModel: {
                                    pageSize: 25,
                                  },
                                },
                              }}
                              pageSizeOptions={[25, 50, 100]}
                            />
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
      </Grid>

      <ConfirmationPopup
        open={deletePopup}
        onClose={handleDeleteClosePopup}
        title="Confirmation"
        textBody="Are you sure you want to delete this  campaign?"
        maxWidth="xs"
        showDivider={true}
        handleUpdateStatus={handleDeleteCampaign}
      />

      <CustomPopup
        open={addPopup}
        onClose={handleCloseAddPopup}
        component={<AddMetaCampaignForm onClose={handleCloseAddPopup} />}
        title="Add Meta Campaign"
        showDivider={true}
      />

      <CustomPopup
        open={editPopup}
        onClose={handleEditClosePopup}
        component={
          <EditMetaCampaignForm
            onClose={handleEditClosePopup}
            selectedData={selectedRowData}
          />
        }
        title="Edit Meta Campaign"
        showDivider={true}
      />

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
